import{defineMessages as e}from"react-intl";const t=e({reviewsCount:{id:"footer.trustpilot.reviews.text",defaultMessage:"Basierend auf {countOfReviews} Bewertungen"}});export{t as default};
//# sourceMappingURL=messages.js.map
